import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import '../../react/styles/antd.less';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import getPropertyFromRootNodeDataAttr from '../shared/utils/getPropertyFromRootNodeDataAttr';
import PublicFeedback from './views';
import { ResourceUserCamelized, SimpleProjectCamelized } from '../embed/auth';
import { AnalyticsProvider } from '../providers/Analytics';
import { CreateTaskProvider } from '../providers/CreateTask';
import { PublicFeedbackProvider } from '../providers/PublicFeedback';
import camelCaseKeys from 'camelcase-keys';
import { AntdWrapper } from 'appClients/shared/andtwrapper';

const scriptUrl = window.document.currentScript?.getAttribute('src');
const bugsnagKey = getPropertyFromRootNodeDataAttr('bugsnagsidebarnewkey');
const project: SimpleProjectCamelized = camelCaseKeys(
  JSON.parse(getPropertyFromRootNodeDataAttr('project') || '{}'),
  { deep: true }
);
const user: ResourceUserCamelized = camelCaseKeys(
  JSON.parse(getPropertyFromRootNodeDataAttr('user') || '{}'),
  { deep: true }
);

let ErrorBoundary = ({ children }) => children;

if (bugsnagKey && !window.rollbar) {
  Bugsnag.start({
    apiKey: bugsnagKey,
    plugins: [new BugsnagPluginReact()]
  });

  //@ts-ignore
  ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React);
  window.bugsnagClient = Bugsnag;
}

declare global {
  interface Window {
    BugHerdConfig?: any;
    bugsnagClient?: any;
    BUGHERD_REACT_APP_SIDEBAR_MOUNT: HTMLElement;
    BUGHERD_API_KEY: string;
  }
}

const App: FC<{}> = ({}) => {
  const apiUrl = new URL(scriptUrl as string);
  const apiDomain = apiUrl.origin;

  return (
    <ErrorBoundary>
      <AnalyticsProvider apiDomain={apiDomain}>
        <CreateTaskProvider project={project} apiDomain={apiDomain} user={user}>
          <PublicFeedbackProvider>
            <PublicFeedback />
          </PublicFeedbackProvider>
        </CreateTaskProvider>
      </AnalyticsProvider>
    </ErrorBoundary>
  );
};

ReactDOM.render(
  <AntdWrapper>
    <App />
  </AntdWrapper>,
  //@ts-ignore
  window.BUGHERD_REACT_APP_SIDEBAR_MOUNT
);
